// Packages
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import Moment from 'react-moment';
import { CircularProgressbar } from 'react-circular-progressbar';

// Relatives
import ParticipantList from './ParticipantList';

// Style
import 'react-circular-progressbar/dist/styles.css';

const Fundraiser = forwardRef((props, ref) => {
  const { id, name, address, fromDate, toDate, participants, bgImage, avatarImage, goalProgress } = props;
  const bgStyle = {};
  if (bgImage) {
    bgStyle.backgroundImage = `url(${bgImage})`;
  }

  const avatarStyle = {};
  if (avatarImage) {
    avatarStyle.backgroundImage = `url(${avatarImage})`;
  }

  return (
    <div ref={ref} className="fundraiser">
      <div className="fundraiser__bg" style={bgStyle} />
      <div className="fundraiser__header">
        <div className="fundraiser__time">
          <div className="time__item">
            <div className="time__type">FROM</div>
            <div className="time__date">
              <Moment style={{ whiteSpace: 'pre' }} format={'MMM[\n]DD'}>
                {fromDate}
              </Moment>
            </div>
            <div className="time__time">
              <Moment format="HH:mm">{fromDate}</Moment>EST
            </div>
          </div>
          <div className="time__item">
            <div className="time__type">TO</div>
            <div className="time__date">
              <Moment style={{ whiteSpace: 'pre' }} format={'MMM[\n]DD'}>
                {toDate}
              </Moment>
            </div>
            <div className="time__time">
              <Moment format="HH:mm">{toDate}</Moment>
              <span>EST</span>
            </div>
          </div>
        </div>
        <div className="fundraiser__progress">
          <CircularProgressbar value={goalProgress} text={`${goalProgress}%`} />
        </div>
      </div>
      <div className="fundraiser__body" />
      <div className="fundraiser__footer">
        <div className="footer__left">
          <div className="fundraiser__owner">
            <div className="owner__avatar" style={avatarStyle} />
          </div>
          <div className="fundraiser__details">
            <div className="fundraiser__name">{name}</div>
            <div className="fundraiser__address">{address}</div>
          </div>
        </div>
        <div className="footer__right">
          <div className="fundraiser__participants">
            {/* <div className="participants__title">Supporters</div> */}
            <ParticipantList items={participants} eventId={id} />
          </div>
        </div>
      </div>
    </div>
  );
});

Fundraiser.defaultProps = {
  id: 0,
  name: '',
  bgImage: '',
  avatarImage: '',
  address: '',
  fromDate: 0,
  toDate: 0,
  goalProgress: 0,
  participants: []
};

Fundraiser.propTypes = {
  id: PropTypes.number,
  name: PropTypes.string,
  bgImage: PropTypes.string,
  avatarImage: PropTypes.string,
  address: PropTypes.string,
  fromDate: PropTypes.number,
  toDate: PropTypes.number,
  goalProgress: PropTypes.number,
  participants: PropTypes.array
};

export default Fundraiser;
